import { Layout } from 'app/layout/layout.types';

// Types
export type Scheme = 'auto' | 'dark' | 'light';
export type Theme = 'default' | string;

/**
 * AppConfig interface. Update this interface to strictly type your config
 * object.
 */
export interface AppConfig
{
    layout: Layout;
    scheme: Scheme;
    theme: Theme;
    main: string;
}

/**
 * Default configuration for the entire application. This object is used by
 * ioteqConfigService to set the default configuration.
 *
 * If you need to store global configuration for your app, you can use this
 * object to set the defaults. To access, update and reset the config, use
 * ioteqConfigService and its methods.
 */
export const appConfig: AppConfig = {
    //layout: 'classy',
    layout: 'classy',
    scheme: 'light',
    theme : 'default',
    main: "ioteq"
};
